import React from 'react'

import { Link, useNavigate } from 'react-router-dom'

// MUI Imports
import {
  IconButton,
  Grid,
  Chip,
  Card,
  CardContent,
  Typography,
  Divider
} from '@mui/material'
import MailOutlineIcon from '@mui/icons-material/MailOutline'

import Flag from '../atoms/Flag'

import { useGlobalStoreData } from '../../../../../store/globalStore'

const CampaignCardList = (props) => {
  const { data } = props
  const navigate = useNavigate()

  const languageGSD = useGlobalStoreData.language()

  const getLinkTarget = (campaignData) => ({
    wizard: `${process.env.PUBLIC_URL}/${languageGSD}/mailing/wizard?b2bAccountId=${campaignData.b2bAccountId}&b2bCampaignId=${campaignData.id}`,
    inbox: `${process.env.PUBLIC_URL}/${languageGSD}/mailing/inbox?b2bCampaignId=${campaignData.id}`
  })

  return (
    <Grid item container spacing={4}>
      {data &&
        data.map((item, index) => {
          return (
            <Grid item key={index} xs={6} md={4} lg={3}>
              <Link to={getLinkTarget(item).wizard}>
                <Card sx={{ minHeight: 200, height: '100%' }}>
                  <CardContent >
                    <div className='flex justify-between gap-2'>
                      <div>
                        <Typography
                          variant='h5'
                          onClick={e => e.preventDefault()}
                          className='hover:text-primary'
                        >
                          {item.name}
                        </Typography>
                        <Typography>
                          {item.productName}
                        </Typography>
                      </div>
                      <div className='flex flex-col gap-2'>
                        <Flag code={item.currentCountryCode} square style={{ fontSize: '2rem', borderRadius: '20%', boxShadow: 'var(--mui-customShadows-primary-md)' }} />
                        <Flag code={item.importerCountryCode} square style={{ fontSize: '2rem', borderRadius: '20%', boxShadow: 'var(--mui-customShadows-primary-md)' }} />
                      </div>
                    </div>
                  </CardContent>
                  <Divider />
                  <CardContent className='flex justify-between align-start gap-1'>
                    <IconButton
                      onClick={(e) => {
                        e.preventDefault()
                        navigate(getLinkTarget(item).inbox)
                      }}
                      color='primary'
                    >
                      <MailOutlineIcon/>
                    </IconButton>
                    <div className='flex flex-wrap items-center gap-1'>
                      {item.hsCodes.map((hs, index) => {
                        return (
                          <Chip
                            key={index}
                            label={hs}
                            size='small'
                          />
                        )
                      })}
                    </div>
                  </CardContent>
                </Card>
              </Link>
            </Grid>
          )
        })}
    </Grid>
  )
}

export default CampaignCardList
